import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

const ServiceInvoiceTable = Loadable(
  lazy(() =>
    import("./ServiceInvoiceTable").then(({ ServiceInvoiceTable }) => ({
      default: ServiceInvoiceTable,
    })),
  ),
);

const ManageSingleServiceInvoice = Loadable(
  lazy(() =>
    import("./ManageSingleServiceInvoice").then(
      ({ ManageSingleServiceInvoice }) => ({
        default: ManageSingleServiceInvoice,
      }),
    ),
  ),
);

export const serviceInvoiceRoutes = [
  {
    path: app_navbar_routes.app.serviceInvoice.serviceInvoice,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_INVOICE]}>
        <ServiceInvoiceTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.approvals.service_invoice,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.APPROVAL_SERVICE_INVOICE]}>
        <ServiceInvoiceTable module="APPROVAL" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.serviceInvoice.serviceInvoice}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_INVOICE]}>
        <ManageSingleServiceInvoice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.serviceInvoice.serviceInvoice}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_INVOICE]}>
        <ManageSingleServiceInvoice />
      </AuthorizedRoute>
    ),
  },
];
